import React, {useEffect} from "react";
import { Col, Container, Row } from "react-bootstrap";
import SectionSubHeader from "../sectionSubHeader";
import SectionHeader from "../sectionHeader";
import CustomButton from "../CustomButton";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";

const WhyChoose = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  return (
    <div className="section-bg why-choose">
      <Container className="" >
        <Row>
        <Col lg={6}> 
          <img src="images/why-choose.svg" alt="Why choose VOLTO" />
          </Col>
          <Col lg={6} className="pt-40">
           <SectionHeader mainText1="WHY CHOOSE VOLTO"  />
            <SectionSubHeader headerText="Join Volto for Global Impact" />
            <p className="text-justify">At Volto Consulting, you will be a part of collaborative global team of exceptional peers whose work has a transformational impact on the lives of millions around the world.</p>
            <CustomButton buttonText="View Open Positions" buttonType="FooterBtn" arrow onClick={()=>navigate('/career#open-position')}/>
          </Col>
        
        </Row>
      </Container>
       
    </div>
  );
};

export default WhyChoose;
